module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.7eaeb144ea0398aac281.js");
};